import PropTypes from 'prop-types'
import { OptionCardStyled, OptionText } from './styled-components'
import OptionIconComponent from '@/containers/SubscriptionFormPageNew/Components/CreateContractModal/OptionIconComponent'

const OptionCard = ({ hidden, onClick, selected, text, iconName }) => {
  const selectedStyle = {
    border: '0.25rem solid #015AA3',
    '--icon-color': '#015AA3',
  }
  if (hidden) {
    return null
  }
  return (
    <OptionCardStyled onClick={onClick} style={selected ? selectedStyle : {}}>
      <OptionIconComponent iconName={iconName} alt={text} />
      <OptionText>{text}</OptionText>
    </OptionCardStyled>
  )
}

OptionCard.propTypes = {
  hidden: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
}

export default OptionCard
